import React from "react";
import ToggleSwitchIcon from "../../shared/icons/ToggleSwitchIcon";
import styles from "./UnifiedOrderCreation.module.scss";

export const CreationCard = ({ title, counter, children }) => (
  <section className={styles.card}>
    <h3 className={styles.heading}>
      <span>{counter}</span>
      {title}
    </h3>
    {children}
  </section>
);

export const CreationToggle = ({ title, description, checked, onChange, icon: Icon, disabled = false }) => (
  <div className={styles.toggleRow}>
    {Icon && <Icon className={styles.icon} aria-hidden="true" />}
    <div className={styles.toggleText}>
      <span>{title}</span>
      {description && <small>{description}</small>}
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={title}
      className={styles.switch}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <ToggleSwitchIcon type={checked ? 1 : 0} />
    </button>
  </div>
);
